import React from "react";
import { enableBodyScroll, disableBodyScroll } from "../../utils/dom";

export interface ModalContent {
  html: any;
  title: string;
}

export interface ModalButtonContent {
  text: string;
  action: Function;
}

export enum ModalType {
  TEXT = "TEXT",
  IFRAME = "IFRAME"
}

interface ModalState {
  isVisible: boolean;
}

interface ModalProps {}

class Modal extends React.Component<ModalProps, ModalState> {
  type: ModalType = ModalType.TEXT;
  content: ModalContent = null;
  onClose: Function = null;
  button: ModalButtonContent = null;
  iFrameUrl: string = "";

  constructor(props: ModalProps) {
    super(props);

    this.state = {
      isVisible: false
    };
  }

  componentDidMount(): void {
    document.addEventListener("keydown", e => this.handleKeyDown(e));

    window.addEventListener(
      "showModal",

      (e: any): void => {
        const { content, onClose, button, type, iFrameUrl } = e.detail;
        if (type) {
          this.type = type;
        }

        this.content = content;
        this.onClose = onClose || function() {};
        this.button = button;

        if (this.type === ModalType.IFRAME) {
          this.iFrameUrl = iFrameUrl;
        }

        this.show();
      }
    );
  }

  componentWillUnmount(): void {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(e): void {
    if (this.state.isVisible && e.keyCode === 27) {
      this.close();
    }
  }

  show(): void {
    disableBodyScroll();
    this.setState({ isVisible: true });
  }

  close(): void {
    this.setState({ isVisible: false }, () => {
      enableBodyScroll();

      if (this.onClose) {
        this.onClose.call(this);
      }
    });
  }

  render() {
    const { content, button, state, type, iFrameUrl } = this;
    const { isVisible } = state;

    return (
      <section className={`modal ${isVisible ? "modal--visible" : ""} `}>
        <div className="modal__overlay" onClick={() => this.close()} />
        <div
          className={`modal__content ${type === ModalType.TEXT ? "modal__content--text" : "modal__content--iframe"}`}
        >
          <div className="modal__close" onClick={() => this.close()} />

          {type === ModalType.TEXT ? (
            <div>
              {content && <h4 className="modal__title">{content.title}</h4>}
              {content && <div className="modal__copy" dangerouslySetInnerHTML={{ __html: content.html }} />}
              {button && (
                <p className="modal__btnWrap">
                  <button
                    className="btn"
                    onClick={e => {
                      e.preventDefault();
                      button.action();
                    }}
                  >
                    {button.text}
                  </button>
                </p>
              )}
            </div>
          ) : (
            <div className="modal__iframeWrap">
              <iframe className="modal__iframe" src={iFrameUrl} frameBorder="0" />
            </div>
          )}
        </div>
      </section>
    );
  }
}

export default Modal;
